export default "__VITE_ASSET__8fe9efb0__"